import { render, staticRenderFns } from "./SsoEntry.vue?vue&type=template&id=6a633fee&scoped=true"
import script from "./SsoEntry.vue?vue&type=script&lang=js"
export * from "./SsoEntry.vue?vue&type=script&lang=js"
import style0 from "./SsoEntry.vue?vue&type=style&index=0&id=6a633fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a633fee",
  null
  
)

export default component.exports